import { GoldenDomeNotificationType } from "@redotech/redo-model/golden-dome-notifications";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getAllGoldenDomeNotifications = {
  name: "getAllGoldenDomeNotifications" as const,
  input: z.object({}),
  output: z.array(
    z.object({
      _id: zExt.objectId(),
      userEmail: z.string(),
      appIds: z.array(z.string()),
      notificationsSent: z.array(
        z.object({
          timestamp: z.date(),
          teamId: z.string(),
          appId: z.string(),
        }),
      ),
      createdAt: z.date(),
      updatedAt: z.date(),
      title: z.string().optional(),
      customMessage: z.string().optional(),
      notificationType: createEnum(GoldenDomeNotificationType),
      includeAppInstallationRemoved: z.boolean().optional(),
      user: z
        .object({
          name: z.object({ first: z.string(), last: z.string() }),
          email: z.string(),
        })
        .optional(),
    }),
  ),
};

export type GetAllGoldenDomeNotificationsOutput = z.infer<
  typeof getAllGoldenDomeNotifications.output
>;
